/**
 * Created by slava on 2/5/19
 */

const RpgLifeView = cc.Node.extend({
    ctor: function (options) {
        this.maxAmount = options.maxAmount || options.amount;
        this.amount = options.amount;
        this.bonus = options.bonus;

        const styles = cleverapps.styles.RpgLifeView;

        this._super();

        this.hurtAnimations = options.hurtAnimations || [Actor.ANIMATIONS.HURT];

        this.object = options.object;
        this.object.addChild(this);

        this.setAlignment(styles);

        const amount = this.bonus ? this.maxAmount - this.amount : this.amount;
        const bar = this.bar = new ScaledProgressBar({
            progress: bundles.progress_bar.frames.bar_life,
            background: bundles.progress_bar.frames.bg_life,
            barText: {
                text: "%from%",
                font: cleverapps.styles.FONTS.RPG_LIFE_VIEW_TEXT
            }
        });
        bar.setCascadeColorEnabled(true);
        bar.setGoal(this.maxAmount);
        bar.setPercentage(amount);
        bar.setLength(styles.bar.width);
        if (styles.bar.color) {
            bar.setColor(styles.bar.color);
        }
        bar.setScale(styles.bar.scale || 1);
        this.addChild(bar);

        const icon = this.icon = options.icon;
        icon.setAnchorPoint(0.5, 0.5);
        this.addChild(icon);
        icon.setAlignment(styles.icon);
    },

    getTarget: function () {
        return this.bar.barText;
    },

    isLow: function () {
        return this.amount < this.maxAmount * 0.3;
    },

    animateDead: function () {
        this.object.shake();
    },

    updateLife: function (amount) {
        if (this.amount !== amount && (this.bonus ? this.bar.from > this.maxAmount - amount : this.bar.from < amount)) {
            return;
        }

        const styles = cleverapps.styles.RpgLifeView;

        amount = this.bonus ? this.maxAmount - amount : amount;
        this.bar.setGoal(this.maxAmount);
        this.bar.setPercentage(amount);
        const color = this.isLow() ? styles.bar.colorLow : styles.bar.color;
        if (color) {
            this.bar.setColor(color);
        }
    },

    updateAmount: function (amount, options) {
        options = options || {};
        if (amount < 0) {
            amount = 0;
        }

        if (amount === this.amount && !options.silent) {
            if (amount === 0) {
                this.runAction(new cc.Sequence(
                    new cc.DelayTime(options.delay || 0),
                    new cc.CallFunc(() => {
                        this.animateDead();
                    })
                ));
            }
            return;
        }

        const styles = cleverapps.styles.RpgLifeView;

        let diff = amount - this.amount;

        if (this.maxAmount < amount) {
            this.maxAmount = amount;
        }

        let dead = false;
        if (this.amount === 0) {
            dead = true;
        }
        this.amount = amount;

        const animateOptions = {};
        if (cleverapps.config.name === "runes" && options.actionBefore && this.object.alive && !this.object.animationRunning) {
            animateOptions.callback = this.updateLife.bind(this, amount);
        } else {
            this.runAction(new cc.Sequence(
                new cc.DelayTime(options.delay || 0),
                new cc.CallFunc(() => {
                    this.updateLife(amount);
                })
            ));
        }

        let actions = new cc.Sequence(
            new cc.DelayTime(options.delay || 0),
            new cc.CallFunc(() => {
                let animation = Actor.ANIMATIONS.IDLE;
                if (diff < 0) {
                    animation = PseudoRandom.GET().mathChoose(this.hurtAnimations);
                    if (amount === 0) {
                        if (options.silent) {
                            animation = Actor.ANIMATIONS.DIE_IDLE;
                        } else {
                            animation = Actor.ANIMATIONS.DIE;
                            this.runAction(new cc.ScaleTo(0.3, 0));
                        }
                    }
                } else if (!options.silent) {
                    animation = Actor.ANIMATIONS.HEAL;
                    if (dead) {
                        animation = Actor.ANIMATIONS.REVIVE;
                        this.runAction(new cc.ScaleTo(0.3, 1));
                    }
                }

                this.object.animate(animation, animateOptions);
            })
        );

        if (!options.silent && styles.delta) {
            let font = cleverapps.styles.FONTS.RPG_LIFE_DELTA_RED;
            if (diff > 0 || !styles.delta.hurtOnCollect) {
                diff = diff < 0 ? -1 * diff : diff;
                font = cleverapps.styles.FONTS.RPG_LIFE_DELTA_GREEN;
            }

            actions = new cc.Sequence(
                actions,
                new cc.CallFunc(() => {
                    cleverapps.aims.showDelta(diff, this.object, {
                        x: this.object.width / 2 * (1.5 - Math.random()),
                        y: this.object.height * 3 / 4 * (1.5 - Math.random()),
                        font
                    });
                })
            );
        }
        this.runAction(actions);
    }
});

cleverapps.styles.RpgLifeView = {
    icon: {
        x: { align: "center", dx: -100 },
        y: { align: "center" }
    },

    bar: {
        width: 200,
        color: cleverapps.styles.COLORS.WHITE,
        colorLow: cleverapps.styles.COLORS.COLOR_RED,
        x: 0,
        y: 0
    },

    delta: {
        hurtOnCollect: true
    },

    x: { align: "center" },
    y: { align: "bottom", dy: -40 }
};
